module.exports = __webpack_public_path__ + "img/metaData.4a798dee.png";